module.exports = __webpack_public_path__ + "static/01-e3215dc3ecb651d634e02c96e0273216.jpg";